import React, { useRef } from "react";
import Header from "./Header";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa';
import { offer } from "../../Data/data";
import { Buttons } from "../Buttons";


const Offer = () => {
  const swiperRef = useRef(null);

  return (
    <div className="w-full h-full bg-black px-[4rem] py-[5rem] flex justify-center items-cetner gap-[2rem] flex-wrap">
      <Header
        title={"What We Offer"}
        subtitle={"Comprehensive Real Estate & Property Management Services"}
        description={
          "We provide full-service real estate and property management solutions throughout San Francisco and the Bay Area. Our services are designed to protect your investment, increase occupancy, streamline operations, and maximize property value."
        }
      />
      {/* Slider  */}
       <div className="w-full flex justify-center relative">
  <Swiper
    modules={[Navigation, Autoplay]}
    onSwiper={(swiper) => (swiperRef.current = swiper)}
    slidesPerView={1} // default for mobile
    spaceBetween={20}
    loop={true}
    centeredSlides={true} // center first slide on mobile
    autoplay={{ delay: 2500, disableOnInteraction: false }}
    breakpoints={{
      480: { slidesPerView: 1, spaceBetween: 10, centeredSlides: true },
      640: { slidesPerView: 2, spaceBetween: 15, centeredSlides: false },
      768: { slidesPerView: 2, spaceBetween: 20, centeredSlides: false },
      1024: { slidesPerView: 3, spaceBetween: 20, centeredSlides: false },
      1280: { slidesPerView: 3, spaceBetween: 20, centeredSlides: false },
    }}
    navigation={false}
    className="crafted-swiper w-full max-w-[1280px]"
  >
    {offer?.map((item, index) => (
      <SwiperSlide key={index} className="flex justify-center ">
        {/* Fixed width card, prevent shrinking */}
        <div
  className="flex-shrink-0 border border-[#FFFFFF33] rounded-lg h-[750px] w-[100%] sm:w-[300px] md:w-[400px]
             flex flex-col justify-start items-start p-[1.5rem] gap-[1rem]"
>
  {/* Image */}
  <img
    src={item.img}
    alt=""
    className="w-full h-[200px] object-cover rounded-lg"
  />

  {/* Title */}
  <h1 className="text-gradient font-bold text-[18px] w-full">{item.title}</h1>

  {/* Detail / Description */}
  <p className="text-white font-light text-[16px] w-full">{item.detail}</p>

  {/* Points List */}
  <ul className="list-disc pl-5 w-full space-y-1">
    {item.point.map((data, index) => (
      <li key={index} className="text-white font-light text-[16px]">
        {data}
      </li>
    ))}
  </ul>

  {/* Button */}
  <div className="w-full mt-auto">
    <Buttons title={item.button} width="100%" to="/contact" />
  </div>
</div>
      </SwiperSlide>
    ))}
  </Swiper>

  {/* Prev Button */}
  <button
    onClick={() => swiperRef.current?.slidePrev()}
    className="absolute md:top-1/2 top-[103%] left-0 sm:left-[-30px] md:left-[40px] w-10 h-10 sm:w-12 sm:h-12 gradient rounded-full flex items-center justify-center -translate-y-1/2 z-20 shadow-lg hover:scale-110 transition-all"
  >
    <FaAngleLeft className="text-black text-xl sm:text-2xl" />
  </button>

  {/* Next Button */}
  <button
    onClick={() => swiperRef.current?.slideNext()}
    className="absolute md:top-1/2 top-[103%] right-0 sm:right-[-30px] md:right-[50px] w-10 h-10 sm:w-12 sm:h-12 gradient rounded-full flex items-center justify-center -translate-y-1/2 z-20 shadow-lg hover:scale-110 transition-all"
  >
    <FaAngleRight className="text-black text-xl sm:text-2xl" />
  </button>
</div>
    </div>
  );
};

export default Offer;
